module.exports = __webpack_public_path__ + "fonts/immortal.5b003b64.ttf";